import classNames from 'classnames';
import React from 'react';
import * as styles from './GutterButton.module.scss';
import IconButton from '../components/IconButton';

const GutterButton = ({
  children,
  className,
  ...props
}: React.ComponentProps<typeof IconButton>) => {
  return (
    <IconButton className={classNames(styles.button, className)} {...props}>
      {children}
    </IconButton>
  );
};

export default GutterButton;
